import { Button } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { useStepState } from '../../../../components/step/useStepState';
import { SectionTitle } from '../../../../components/text';
import { TranslationsKeys } from '../../../../locales/translations';
import { updateAcademicOfferCurrentStep } from '../api';
import { useAcademicOfferWizard } from '../context/AcademicOfferWizardContext';
import { CeAcademicOfferStepEnum } from '../types';

export function AcademicOfferSchedule() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { nextStep, prevStep } = useStepState();
  const { ceAcademicOfferId } = useAcademicOfferWizard();

  const handleNext = async () => {
    if (!ceAcademicOfferId) {
      return;
    }
    await updateAcademicOfferCurrentStep(
      ceAcademicOfferId,
      CeAcademicOfferStepEnum.Summary,
    );
    nextStep();
  };

  const handleBack = async () => {
    if (!ceAcademicOfferId) {
      return;
    }
    await updateAcademicOfferCurrentStep(
      ceAcademicOfferId,
      CeAcademicOfferStepEnum.Sections,
    );
    prevStep();
  };

  return (
    <>
      <SectionTitle text={t('wizard.steps.horario')} />
      <div className="py-5 text-center text-muted">
        {t('wizard.placeholder')}
      </div>
      <Row>
        <Col xs={12} md={6} lg={4} className="offset-md-6 offset-lg-8">
          <Row>
            <Col>
              <Button
                text={t('wizard.back')}
                outlined
                fullwidth
                onClick={handleBack}
              />
            </Col>
            <Col>
              <Button text={t('wizard.next')} fullwidth onClick={handleNext} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
